import React, { useContext } from 'react';

export interface HelpDrawerState {
    back(): void;
    navigate(view: React.JSX.Element): void;
}

export const HelpDrawerContext = React.createContext<HelpDrawerState | undefined>(undefined);

export function useHelpDrawer(): HelpDrawerState {
    const context = useContext(HelpDrawerContext);

    if (!context) {
        throw new Error('useAppDrawer must be nested inside a AppDrawerProvider');
    }

    return context;
}
